export var AssessmentKind;
(function (AssessmentKind) {
    AssessmentKind["initialAssessment"] = "initial_assessment";
    AssessmentKind["conditionsScreening"] = "conditions_screening";
    AssessmentKind["progressUpdate"] = "progress_update";
    AssessmentKind["sprass"] = "sprass";
    AssessmentKind["conditionsCheckIn"] = "conditions_check_in";
    AssessmentKind["goalCheckIn"] = "goal_check_in";
    AssessmentKind["migrated"] = "migrated";
})(AssessmentKind || (AssessmentKind = {}));
export var AssessmentStatus;
(function (AssessmentStatus) {
    AssessmentStatus["finished"] = "Finished";
    AssessmentStatus["requested"] = "Requested";
    AssessmentStatus["started"] = "Started";
    AssessmentStatus["cancelled"] = "Cancelled";
})(AssessmentStatus || (AssessmentStatus = {}));
export var QuestionnaireKinds;
(function (QuestionnaireKinds) {
    QuestionnaireKinds["Asrs"] = "ASRS";
    QuestionnaireKinds["Audit"] = "AUDIT";
    QuestionnaireKinds["Auditc"] = "AUDITC";
    QuestionnaireKinds["Dast10"] = "DAST10";
    QuestionnaireKinds["Epds"] = "EPDS";
    QuestionnaireKinds["Gad2"] = "GAD2";
    QuestionnaireKinds["Gad7"] = "GAD7";
    QuestionnaireKinds["Issues"] = "Issues";
    QuestionnaireKinds["Mdq"] = "MDQ";
    QuestionnaireKinds["Pcptsd"] = "PCPTSD";
    QuestionnaireKinds["Phq2"] = "PHQ2";
    QuestionnaireKinds["Phq9"] = "PHQ9";
    QuestionnaireKinds["Qids"] = "QIDS";
    QuestionnaireKinds["Scoff"] = "SCOFF";
    QuestionnaireKinds["Sds"] = "SDS";
    QuestionnaireKinds["Sib"] = "SIB";
    QuestionnaireKinds["Sprass"] = "SPRASS";
})(QuestionnaireKinds || (QuestionnaireKinds = {}));
